const Theme = {
  colors: {
    primary: "black",
    secondary: "#AC4264",
    tertiary: "#298BA2",
    dark: "#262B40",
    light: "rgb(241, 242, 254)"
  }
};

export default Theme;
